import { getMaintenance } from '@/services/maintenances-service/maintenances-service';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export const useMaintenance = (id: number) => {
  const {
    data: maintenanceData,
    error,
    isPending,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.MAINTENANCE(id),
    queryFn: () => getMaintenance(id),
    enabled: !!id,
  });

  return { maintenanceData, error, isPending, refetch };
};
